// Privacy page translations
const privacyTranslations = {
  en: {
    hero: {
      pill: "Privacy Policy",
      title: "Privacy Policy",
      subtitle: "Protecting your personal data is a matter of particular importance to us. We treat your personal data confidentially and in accordance with the applicable data protection regulations as well as this privacy policy."
    },
    sections: {
      dataProtection: {
        title: "Data Protection",
        items: {
          controller: {
            label: "1. Controller",
            content: [
              { strong: "thewhizkind" },
              "Prayrit Singh",
              "Email: <email>prayrit@thewhizkind.com</email>"
            ]
          },
          dataCollection: {
            label: "2. Data Collection on This Website",
            content: [
              "Some of your data is collected when you provide it to us — for example, by sending us an email. Other data is automatically collected by our IT systems when you visit the website (e.g., browser type, operating system, or the time of page access)."
            ]
          },
          hosting: {
            label: "3. Hosting",
            content: [
              "This website is hosted by Hostinger International Ltd, 61 Lordou Vironos Street, 6023 Larnaca, Cyprus.",
              "Hostinger processes your data only to the extent necessary to fulfill its service obligations and follows our instructions in accordance with a data processing agreement (Article 28 GDPR)."
            ]
          },
          vercel: {
            label: "4. Vercel",
            content: [
              "For building and deploying this website, as well as for our contact form, we use Vercel Inc., 340 S Lemon Ave #4133, Walnut, CA 91789, USA.",
              "Whenever changes to the source code are pushed to GitHub, Vercel automatically builds and deploys the website. In addition, Vercel processes the data submitted through the contact form via serverless functions and forwards it to our email address. Technical data such as your IP address may be processed in this context.",
              "The transfer of data to the USA is based on the EU Standard Contractual Clauses (Article 46(2)(c) GDPR). For further information, please see Vercel's privacy policy: <link>https://vercel.com/legal/privacy-policy</link>"
            ]
          },
          github: {
            label: "5. GitHub",
            content: [
              "The source code of this website is managed via GitHub Inc., 88 Colin P Kelly Jr St, San Francisco, CA 94107, USA. Pushing to the repository triggers the automatic deployment process described in Section 4 via the GitHub–Vercel integration.",
              "GitHub is used exclusively for version control and deployment of the website. No personal data of website visitors is processed in this context.",
              "For further information, please see GitHub's privacy statement: <link>https://docs.github.com/site-policy/privacy-policies/github-privacy-statement</link>"
            ]
          },
          sslEncryption: {
            label: "6. SSL or TLS Encryption",
            content: [
              "For security reasons, this site uses SSL or TLS encryption. You can recognize an encrypted connection by the fact that the browser's address bar begins with 'https://'."
            ]
          },
          analytics: {
            label: "7. Analytics and Cookies",
            content: [
              "We use Google Analytics, a web analytics service provided by Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Ireland.",
              "Google Analytics allows us to analyse how our website is used and to improve our services. This may include information such as page views, user interactions, and technical data, for example browser type and device details.",
              "This data is processed only after you have given your consent through the cookie banner.",
              "The legal basis for this processing is your consent, in accordance with Article 6(1)(a) GDPR.",
              "You may withdraw your consent at any time by adjusting your browser settings or clearing your local storage.",
              "For further information, please see Google's privacy policy: <link>https://policies.google.com/privacy</link>"
            ]
          },
          scope: {
            label: "8. Scope of Application",
            content: [
              "This privacy policy applies to websites, web applications and digital services for which thewhizkind is the controller, unless a separate privacy policy applies.",
              "It does not automatically apply to websites, applications or services created, maintained or technically supported by thewhizkind for other people or organisations. The respective operator is responsible for providing the applicable privacy information where they act as the controller."
            ]
          },
          work: {
            label: "9. Work on Websites, Applications and Digital Services",
            content: [
              "As part of our work, thewhizkind designs, develops, maintains and supports websites, web applications, digital tools, automations and other digital services for people and organisations we work with.",
              "In the course of this work, we may technically have access to personal data processed through these systems, for example when providing development, maintenance, troubleshooting, hosting-related support or technical administration.",
              "Where thewhizkind processes personal data on behalf of another person or organisation, that person or organisation generally remains the controller for the respective processing and thewhizkind acts as a processor within the meaning of Article 28 GDPR, where applicable.",
              "Such processing is limited to what is necessary to provide the agreed services and is carried out in accordance with the instructions of the respective controller.",
              "We do not use personal data accessed through these systems for our own independent purposes.",
              "Depending on the project, additional service providers and technical infrastructure may be involved. The applicable data protection arrangements are determined according to the individual project."
            ]
          },
          contact: {
            label: "10. Contact",
            content: [
              "If you contact us via email, the information you provide, including your contact details, will be stored for the purpose of processing your inquiry and in case of follow-up questions. We do not share this data without your consent."
            ]
          }
        }
      }
    }
  },
  de: {
    hero: {
      pill: "Datenschutzerklärung",
      title: "Datenschutz­erklärung",
      subtitle: "Der Schutz deiner persönlichen Daten ist uns ein besonderes Anliegen. Wir behandeln deine personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung."
    },
    sections: {
      dataProtection: {
        title: "Datenschutz",
        items: {
          controller: {
            label: "1. Verantwortlicher",
            content: [
              { strong: "thewhizkind" },
              "Prayrit Singh",
              "E-Mail: <email>prayrit@thewhizkind.com</email>"
            ]
          },
          dataCollection: {
            label: "2. Datenerfassung auf dieser Website",
            content: [
              "Deine Daten werden zum einen dadurch erhoben, dass du uns diese mitteilst — z. B. durch das Versenden einer E-Mail an uns. Andere Daten werden automatisch beim Besuch der Website durch IT-Systeme erfasst (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs)."
            ]
          },
          hosting: {
            label: "3. Hosting",
            content: [
              "Diese Website wird gehostet bei Hostinger International Ltd, 61 Lordou Vironos Street, 6023 Larnaca, Zypern.",
              "Hostinger verarbeitet deine Daten nur soweit erforderlich zur Erfüllung seiner Leistungspflichten und folgt unseren Weisungen im Rahmen eines Auftragsverarbeitungsvertrags (Art. 28 DSGVO)."
            ]
          },
          vercel: {
            label: "4. Vercel",
            content: [
              "Für den Build- und Bereitstellungsprozess (Deployment) dieser Website sowie für unser Kontaktformular nutzen wir Vercel Inc., 340 S Lemon Ave #4133, Walnut, CA 91789, USA.",
              "Sobald Änderungen am Quellcode auf GitHub veröffentlicht werden, baut und veröffentlicht Vercel die Website automatisch. Zusätzlich verarbeitet Vercel die über das Kontaktformular eingegebenen Daten mittels serverloser Funktionen (Serverless Functions) und leitet diese an unsere E-Mail-Adresse weiter. Dabei können technische Daten wie deine IP-Adresse verarbeitet werden.",
              "Die Datenübertragung in die USA erfolgt auf Grundlage der EU-Standardvertragsklauseln (Art. 46 Abs. 2 lit. c DSGVO). Weitere Informationen findest du in der Datenschutzerklärung von Vercel: <link>https://vercel.com/legal/privacy-policy</link>"
            ]
          },
          github: {
            label: "5. GitHub",
            content: [
              "Der Quellcode dieser Website wird über GitHub Inc., 88 Colin P Kelly Jr St, San Francisco, CA 94107, USA, verwaltet. Ein Push auf das Repository löst über die GitHub-Vercel-Integration den im Abschnitt 4 beschriebenen automatischen Deployment-Vorgang aus.",
              "GitHub wird ausschließlich zur Versionsverwaltung und zur Bereitstellung (Deployment) der Website genutzt. Dabei werden keine personenbezogenen Daten von Besucherinnen und Besuchern der Website verarbeitet.",
              "Weitere Informationen findest du in der Datenschutzerklärung von GitHub: <link>https://docs.github.com/site-policy/privacy-policies/github-privacy-statement</link>"
            ]
          },
          sslEncryption: {
            label: "6. SSL- bzw. TLS-Verschlüsselung",
            content: [
              "Diese Seite nutzt aus Sicherheitsgründen eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennst du daran, dass die Adresszeile des Browsers mit 'https://' beginnt."
            ]
          },
          analytics: {
            label: "7. Analyse & Cookies",
            content: [
              "Wir nutzen Google Analytics, einen Webanalysedienst der Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland.",
              "Google Analytics hilft uns dabei, die Nutzung unserer Website auszuwerten und unser Angebot zu verbessern. Dabei werden unter anderem Seitenaufrufe, Interaktionen auf der Website sowie technische Informationen wie Browsertyp und Gerätedaten erfasst.",
              "Die Verarbeitung dieser Daten erfolgt ausschließlich nach deiner Einwilligung über das Cookie-Banner.",
              "Rechtsgrundlage ist deine Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO.",
              "Du kannst deine Einwilligung jederzeit widerrufen, indem du deine Browsereinstellungen änderst oder den lokalen Speicher deines Geräts löschst.",
              "Weitere Informationen findest du in der Datenschutzerklärung von Google: <link>https://policies.google.com/privacy</link>"
            ]
          },
          scope: {
            label: "8. Geltungsbereich",
            content: [
              "Diese Datenschutzerklärung gilt für Webseiten, Webanwendungen und digitale Dienste, für die thewhizkind Verantwortlicher ist, sofern keine gesonderte Datenschutzerklärung gilt.",
              "Sie gilt nicht automatisch für Webseiten, Anwendungen oder Dienste, die von thewhizkind für andere Personen oder Organisationen erstellt, gepflegt oder technisch betreut werden. Der jeweilige Betreiber ist für die Bereitstellung der geltenden Datenschutzinformationen verantwortlich, soweit er als Verantwortlicher handelt."
            ]
          },
          work: {
            label: "9. Arbeiten an Webseiten, Anwendungen und digitalen Diensten",
            content: [
              "Im Rahmen unserer Tätigkeit konzipiert, entwickelt, pflegt und betreut thewhizkind Webseiten, Webanwendungen, digitale Werkzeuge, Automatisierungen und andere digitale Dienste für Personen und Organisationen, mit denen wir zusammenarbeiten.",
              "Im Zuge dieser Tätigkeit können wir technisch auf personenbezogene Daten zugreifen, die über diese Systeme verarbeitet werden, beispielsweise bei der Entwicklung, Wartung, Fehlerbehebung, Unterstützung im Zusammenhang mit Hosting oder technischen Administration.",
              "Soweit thewhizkind personenbezogene Daten im Auftrag einer anderen Person oder Organisation verarbeitet, bleibt diese Person oder Organisation grundsätzlich Verantwortlicher für die jeweilige Verarbeitung, und thewhizkind handelt, soweit anwendbar, als Auftragsverarbeiter im Sinne von Artikel 28 DSGVO.",
              "Eine solche Verarbeitung ist auf das für die Erbringung der vereinbarten Leistungen erforderliche Maß beschränkt und erfolgt gemäß den Weisungen des jeweiligen Verantwortlichen.",
              "Wir verwenden personenbezogene Daten, auf die wir über diese Systeme zugreifen, nicht für eigene, unabhängige Zwecke.",
              "Je nach Projekt können weitere Dienstleister und technische Infrastrukturen beteiligt sein. Die geltenden Datenschutzregelungen werden entsprechend dem jeweiligen Projekt festgelegt."
            ]
          },
          contact: {
            label: "10. Kontaktaufnahme",
            content: [
              "Wenn du uns per E-Mail kontaktierst, werden deine Angaben inklusive der von dir angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen gespeichert. Diese Daten geben wir nicht ohne deine Einwilligung weiter."
            ]
          }
        }
      }
    }
  }
};

export default privacyTranslations;